module["exports"] = [
  "sgate",
  "svei",
  "s Gate",
  "s Vei",
  "gata",
  "veien"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/address/common_street_suffix.js
// module id = 1630
// module chunks = 0